import MAisAutocompleteUsers from './MAISAutocompleteUsers.vue';

export { MAisAutocompleteUsers };
export default MAisAutocompleteUsers;
